<template>
  <Chart :chartData="computedData" :options="computedOptions" />
</template>

<script>
  import ChartMetrics from '@/mixins/ChartMetrics'
  import merge from 'lodash/merge'

  export default {
    name: 'ChartLA',
    mixins: [
      ChartMetrics,
    ],
    computed: {
      computedData() {
        return {
          datasets: [{
            backgroundColor: '#ff9966',
            borderColor: '#ff9966',
            borderWidth: 1,
            data: this.data ? this.data[0]: [],
            fill: false,
            label: '1 min',
            pointRadius: 0,
            spanGaps: false,
          }, {
            backgroundColor: '#6699ff',
            borderColor: '#6699ff',
            borderWidth: 1,
            data: this.data ? this.data[1]: [],
            fill: false,
            label: '5 min',
            pointRadius: 0,
            spanGaps: false,
          }, {
            backgroundColor: '#9933ff',
            borderColor: '#9933ff',
            borderWidth: 1,
            data: this.data ? this.data[2]: [],
            fill: false,
            label: '15 min',
            pointRadius: 0,
            spanGaps: false,
          }]
        }
      },
      computedOptions() {
        return merge(this.options, {
          scales: {
            yAxes: [{
              ticks: {
                min: 0,
                suggestedMax: 1,
                maxTicksLimit: 10,
              },
            }],
          },
        })
      },
    },
  }
</script>
